"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuItem = exports.StyledDropdown = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledDropdown = (0, styled_components_1.default)(ui_components_1.Dropdown) `
  &&& {
    background: transparent;
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 1rem;

    .MuiOutlinedInput-input {
      padding: ${({ theme }) => theme.spacing(1.75)};
      padding-right: ${({ theme }) => theme.spacing(2.5)};
    }

    &:hover {
      .MuiSelect-icon {
        background: none;
      }

      .MuiOutlinedInput-notchedOutline {
        border-color: ${ui_components_1.baseColors.background200};
      }
    }

    .MuiSelect-icon {
      right: 0;

      svg > path {
        fill: ${({ theme }) => theme.palette.grey[400]};
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: ${ui_components_1.baseColors.background100};
      border-width: 1px;
    }
  }
`;
exports.StyledMenuItem = (0, styled_components_1.default)(ui_components_1.MenuItem) `
  border-radius: 4px;
  font-size: 1rem;

  &&.Mui-selected {
    background-color: ${ui_components_1.baseColors.primaryAccentGreen800};
  }

  .children {
    width: calc(100% + 13px);
  }
`;
